<ion-header>
  <ion-toolbar>
    <ion-title> {{ 'exercise.filter.modal.title' | translate }} </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-row class="main-row">
    <ion-col size-xs="12" size-lg="3" class="ion-no-padding ion-padding-horizontal ion-padding-bottom filter-groups-column">
      <div>
        <ng-container *ngIf="!anonymous">
          <h5>
            <ion-row class="ion-justify-content-between ion-align-items-center">

              <ion-row class="ion-align-items-center">
                {{ 'exercise.my.library' | translate }}
                <ion-badge color="secondary" *ngIf="totalSelectedfavoriteOptions > 0" class="ion-margin-start">
                  {{totalSelectedfavoriteOptions}}
                </ion-badge>

                <ion-button
                  fill="clear"
                  size="small"
                  *ngIf="totalSelectedfavoriteOptions > 0"
                  (click)="favoriteRadioControl.setValue(null)"
                  class="ion-no-padding ion-margin-start"
                >
                  <ion-icon name="close-circle-outline" slot="icon-only"></ion-icon>
                </ion-button>

                <me-is-new-badge class="ion-margin-start"></me-is-new-badge>
              </ion-row>


              <ion-button fill="outline" size="small" shape="round" (click)="toggleFavoritesOpenState()">
                <ion-icon name="chevron-up-outline" [class.rotate]="!favoritesSectionOpen"></ion-icon>
              </ion-button>
            </ion-row>
          </h5>
          <div *ngIf="favoritesSectionOpen" @slideUpDown>
            <ion-radio-group [formControl]="favoriteRadioControl">
              <ion-list class="ion-no-padding">
                <ion-item lines="full" *ngFor="let option of favoriteOptions$ | async">
                  <ion-radio [value]="option.type" [disabled]="option.disabled" color="secondary" slot="start"></ion-radio>
                  <ion-label [class.ion-color-medium]="option.disabled">{{ option.i18nKey | translate: (option.i18nParams ?? {}) }} ({{ option.totalsForCurrentQuery }})</ion-label>
                </ion-item>
              </ion-list>
            </ion-radio-group>

            <me-banner>
              <ion-icon size="large" name="information-circle-outline"></ion-icon>
              <div class="text banner-text">{{ 'exercise.filter.modal.favorites.description' | translate }}</div>
            </me-banner>
          </div>

        </ng-container>
        <ng-container *ngIf="exerciseFacets$ | async as exerciseFacets">
          <ng-container *ngFor="let exerciseFacetEntry of exerciseFacets | keyvalue">
            <app-exercise-field-filter [(filtersOpenState)]="filtersOpenState[exerciseFacetEntry.key]"
              [optionsMap]="exerciseFacetEntry.value" [fieldName]="exerciseFacetEntry.key"
              [selectedOptions]="selectedFacets[exerciseFacetEntry.key]"
              (selectedOptionsChange)="onFilterStateChange($event, exerciseFacetEntry.key)"></app-exercise-field-filter>
          </ng-container>
        </ng-container>
      </div>

    </ion-col>
    <ion-col size-xs="12" [attr.size-lg]="moreDetailsExercise ? 6 : 9" class="ion-no-padding">

      <div class="ion-padding-horizontal">

      </div>

      <h5 class="main-header">
        <ion-row class="ion-justify-content-between ion-align-items-center main-header-row">

          <ion-row class="ion-align-items-center">
            <ion-item class="exercise-search-field" fill="outline" lines="none">
              <ion-input type="text" [formControl]="searchInputCtrl"
                [placeholder]="'search.exercise' | translate" class="exercise-search"></ion-input>

            </ion-item>
            <ion-button class="ion-margin-start ion-hide-md-down" fill="outline" size="small" shape="round"
              (click)="resetFilters()">
              {{ 'exercise.filter.modal.reset.filters' | translate }}
            </ion-button>
          </ion-row>


          <span class="ion-hide-md-down">{{ headerText$ | async }}</span>
          <!-- Show on smaller devices -->
          <div class="ion-hide-md-up">{{ headerText$ | async }}</div>
        </ion-row>
      </h5>

      <ion-row class="main-scroll-area">
        <ion-col size-xs="12" size-sm="6" size-xl="4" *ngFor="let exercise of exercises$ | async"
          class="ion-no-padding ion-margin-bottom">
          <ion-card
            class="exercise"
            [class.selected]="moreDetailsExercise?.id == exercise.id"
            (pointerenter)="videoPreviewEnabledId = exercise.id"
            (pointerleave)="videoPreviewEnabledId = null"
          >
            <div class="media-container" [style.aspect-ratio]="exercise.videos[0]?.photoUrl ?? '' | vimeoAspectRatio">
              <img
                [alt]="exercise.name"
                [src]="exercise.videos[0]?.photoUrl"

                loading="lazy"
                image-fade-in
              >
              <me-exercise-video
                *ngIf="videoPreviewEnabledId === exercise.id && exercise.videos[0] as video"
                [video]="exercise.videos[0]"
                [controls]="false"
                [autoplay]="true"
                (loadingChange)="onVideoPreviewLoading($event)"
                [class.hidden]="videoPreviewLoading"
              >
              </me-exercise-video>
              <ion-spinner
                class="video-preview-spinner"
                *ngIf="videoPreviewLoading && videoPreviewEnabledId === exercise.id"
              >
              </ion-spinner>
            </div>

            <ion-card-header>
              <ion-card-title>{{ exercise.name }}</ion-card-title>
            </ion-card-header>
            <ion-row class="ion-justify-content-end ion-margin-end ion-padding-bottom">
              <ion-button fill="outline" class="ion-hide-lg-down" (click)="setMoreDetailsExercise(exercise)">
                {{ 'exercise.more.details' | translate }}
              </ion-button>
              <ion-button fill="outline" (click)="selectExercise(exercise)" *ngIf="!selectedExercises.has(exercise)">
                {{ 'action.select' | translate }}
              </ion-button>
              <ion-button fill="outline" color="danger" (click)="removeExerciseFromSelection(exercise)"
                *ngIf="selectedExercises.has(exercise)">
                {{ 'action.remove' | translate }}
              </ion-button>
            </ion-row>

          </ion-card>
        </ion-col>
      </ion-row>

      <ion-infinite-scroll threshold="100px" (ionInfinite)="loadData($event)" class="ion-padding-top" [disabled]="disableInfiniteScroll$ | async">
        <ion-infinite-scroll-content [loadingText]="'exercise.filter.modal.exercise.loading' | translate">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-col>
    <ion-col *ngIf="moreDetailsExercise" size-lg="3" class="ion-no-padding more-details-exercise">
      <div class="more-details-exercise-container">
        <me-exercise-container class="ion-margin-horizontal" [exercise]="moreDetailsExercise"
          (onCloseClickEvent)="setMoreDetailsExercise(null)"></me-exercise-container>

        <form *ngIf="!anonymous" [formGroup]="moreDetailsExerciseFavoriteForm" class="ion-padding">
          <ion-item lines="none" class="ion-margin-top" fill="outline">
            <ion-checkbox formControlName="isOrganizationFavorite" slot="end"></ion-checkbox>
            <ion-label class="wrap-text">{{ 'exercise.favorite.organisation.label' | translate }}</ion-label>
            <ion-note slot="helper">
              {{ 'exercise.favorite.organisation.description' | translate }}
            </ion-note>
          </ion-item>

          <ion-item lines="none" class="ion-margin-top" fill="outline">
            <ion-checkbox formControlName="isEmployeeFavorite" slot="end"></ion-checkbox>
            <ion-label class="wrap-text">{{ 'exercise.favorite.employee.label' | translate }}</ion-label>
            <ion-note slot="helper">
              {{ 'exercise.favorite.employee.description' | translate }}
            </ion-note>
          </ion-item>
        </form>
      </div>
    </ion-col>
  </ion-row>
</ion-content>

<ion-footer class="ion-padding buttons-container" *ngIf="selectedExercises.size >= 1">
  <ion-row class="ion-justify-content-between ion-align-items-center footer-row">
    <div>
      <h5>
        <ng-container *ngIf="selectedExercises.size === 1">
          {{ 'exercise.filter.selection.message.singular' | translate }}
        </ng-container>
        <ng-container *ngIf="selectedExercises.size > 1">
          {{ 'exercise.filter.selection.message.plural' | translate: {
          count: selectedExercises.size
          }
          }}
        </ng-container>
      </h5>
      <ng-container *ngFor="let selectedExercise of selectedExercises">
        <ion-chip (click)="removeExerciseFromSelection(selectedExercise)">
          <ion-label>{{ selectedExercise.name }}</ion-label>
          <ion-icon color="danger" name="close-circle-outline"></ion-icon>
        </ion-chip>
      </ng-container>
    </div>
    <ion-button color="secondary" (click)="addExercises()">
      <ng-container *ngIf="selectedExercises.size === 1">{{'exercise.filter.modal.add.singular' |
        translate}}</ng-container>
      <ng-container *ngIf="selectedExercises.size > 1">{{'exercise.filter.modal.add.plural' | translate}}</ng-container>
    </ion-button>
  </ion-row>
</ion-footer>
